// import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import { BsInfoCircle } from 'react-icons/bs';
// import { formatDateToShortMonth } from '../ChallengeDetails/View';

// const useStyles = makeStyles((theme) => ({
//   wrapper: {
//     margin: '1rem 0 2rem 0',
//     padding: '1rem',
//     background: '#fff',
//   },
//   title: {
//     fontFamily: 'VodafoneRg-Regular',
//     fontSize: '1.25rem',
//     marginBottom: '1rem',
//     color: '#333',
//   },
//   subtitle: {
//     fontFamily: 'VodafoneRg-regular',
//     fontSize: '1rem',
//     color: '#9b9494',
//     marginBottom: '2rem',
//   },
//   section: {
//     marginTop: '2rem',
//   },
// }));
 
// export const ChallengePreview = (props) => {

//   const classes = useStyles();
//   const { formData, isAdmin , userEmail,innovateCategoryTypes,listIdeaTemplate,listScorecardTemplate,getInnovateChallengeIdDetails,listCommunitesChallenge} = props || {}
//   const items = getInnovateChallengeIdDetails 
//   const showEmail = isAdmin ? userEmail : 'N/A'
//   if (!formData) return null;

//   const {
//     title,
//     summary,
//     category,
//     startingDate,
//     closingDate,
//     termsAndConditions,
//     coverPhoto,
//     templateIdea,
//     templateScorecard,
//     communities,
//     challengeTemplateId,
//     ideaTemplateId,
//     desc,
//     termAndCondition,
//     starts,
//     ends,
//     categoryTypeId,
//     image,
//     groupListK
//   } = items;
//     // console.log("🚀 ~ ChallengePreview ~ coverPhoto:", coverPhoto)
  
//   const selectedType = innovateCategoryTypes.find(
//     (type) => +type.id === +categoryTypeId
//   );

//   const selectedScorecardTemplateName = listScorecardTemplate.find(
//     // (cardName) => (cardName.id === +templateScorecard?.id) 
//     (cardName) => cardName.id === parseInt(challengeTemplateId?.id ?? '', 10)
//   );
//   const selectedIdeaTemplateName = listIdeaTemplate.find(
//     // (cardName) => (cardName.id === +templateIdea?.id)
//     (cardName) => cardName.id === parseInt(ideaTemplateId?.id ?? '', 10)
//   );
//   // console.log("🚀 ~ ChallengePreview ~ selectedScorecardName:", templateScorecard?.id,selectedScorecardTemplateName,selectedIdeaTemplateName)
  

// const communitiesNames = (listCommunitesChallenge || []).filter(grp => groupListK.includes(grp?.id))

// console.log("communitiesNames",communitiesNames , communitiesNames.filter((item)=>item.name))
    
//   const startDataFormat = formatDateToShortMonth(startingDate  || starts?.dateString)
//   const endDataFormat = formatDateToShortMonth(closingDate || ends?.dateString)
  


//   const sections = [
//     {
//       title: 'Challenge Details',
//       subtitle: 'Basic information about your challenge',
//       data: [
//         { label: 'Challenge Title', value: title },
//         { label: 'Challenge Description', value: desc },
//         { label: 'Category', value: selectedType?.name },
//         { label: 'Submission Start Date', value: startDataFormat },
//         { label: 'Submission End Date', value: endDataFormat },
//         { label: 'Challenge Cover Photo', value: coverPhoto  || 'N/A' },
//         { label: 'Terms and Conditions', value: termAndCondition },
//       ],
//     },
//     {
//       title: 'Idea Template Selection',
//       subtitle: 'Details of the selected idea template',
//       data: [
//         { label: 'Selected Idea Template Name', value: selectedIdeaTemplateName?.templateName || 'N/A' },
//       ],
//     },
//     {
//       title: 'Evaluation Workflow',
//       subtitle: 'Details of the selected scorecard template',
//       data: [
//         { label: 'Evaluation Method', value: 'Scorecard' },
//         { label: 'Selected Scorecard Template Name', value: selectedScorecardTemplateName?.templateName  || 'N/A' },
//       ],
//     },
//     {
//       title: 'Owner & Communities',
//       subtitle: 'Challenge ownership and participation settings',
//       data: [
//         { label: 'is Admin', value: isAdmin },
//         { label: 'Challenge Owner', value: showEmail }, 
//         // { label: 'Approval Settings', value: 'True' }, // Replace with dynamic value if available
//         { label: 'Communities', value: communitiesNames.filter((item)=>item.name) || 'N/A' },
//       ],
//     },
//   ];

//   return (
//     <div className={classes.wrapper}>
//       <h2 className={classes.title}>Challenge Summary</h2>
//       <p className={classes.subtitle}>Review your challenge details before submitting</p>

//       {sections.map((section) => (
//         <PreviewSection key={section.title} {...section} />
//       ))}

     
//     </div>
//   );
// };


// const useSectionStyles = makeStyles((theme) => ({
//     sectionBox: {
//       backgroundColor: '#e6000117',
//       borderRadius: '0.5rem',
//       padding: '1rem',
//       marginBottom: '1.5rem',
//     },
//     icon: {
//       display: 'inline-block',
//       backgroundColor: '#e6000117',
//       padding: '4.5px',
//       borderRadius: '50%',
//       marginRight: '0.5rem',
//     },
//     sectionTitle: {
//       fontFamily: 'VodafoneRg-bold',
//       fontSize: '1.125rem',
//       color: '#333',
//       margin: '0.5rem 0',
//     },
//     sectionSubtitle: {
//       fontFamily: 'VodafoneRg-regular',
//       fontSize: '1rem',
//       color: '#333',
//     },
//   }));
  
//   const PreviewSection = ({ title, subtitle, data }) => {
//     // console.log("🚀 ~ PreviewSection ~ data:", data)
//     const classes = useSectionStyles();
  
//     return (
//       <div className={classes.sectionBox}>
//         <div className={classes.icon}><BsInfoCircle /></div>
//         <h3 className={classes.sectionTitle}>{title}</h3>
//         <p className={classes.sectionSubtitle}>{subtitle}</p>
//         {data.map((item) => (<>
//           {/* {console.log("PreviewSection items",item)} */}
//           <PreviewRow key={item.label || item.label} label={item.label} value={item.value} />
//         </>))}
//       </div>
//     );
//   };
  
//   const useRowStyles = makeStyles(() => ({
//     row: {
//       display: 'grid',
//       gridTemplateColumns: '40% 1fr',
//       gap: '1rem',
//       borderBottom: '1px solid #ccc',
//       padding: '1rem 0',
//     },
//     text: {
//       fontFamily: 'VodafoneRg-regular',
//       fontSize: '1rem',
//       color: '#333',
//     },
//   }));
  

//   const isImageUrl = (url) =>
//   typeof url === 'string' &&
//   (url.startsWith('http') || url.startsWith('data:image')) &&
//   /\.(jpg|jpeg|png|gif|webp|svg)$/.test(url); // ignore query params


// const PreviewRow = ({ label, value }) => {
//   const classes = useRowStyles();

//   const renderValue = (val) => {
//     if (val === null || val === undefined) return 'N/A';

//     if (typeof val === 'string' && isImageUrl(val)) {
//       return (
//         <img
//           src={val}
//           alt="preview"
//           style={{ maxWidth: '100px', height: '100px', objectFit: 'cover', display: 'block' }}
//         />
//       );
//     }

    
//     if (Array.isArray(val)) {
//       return (
//         <ul style={{ margin: 0, paddingLeft: '1rem' }}>
//           {val.map((item) => (
//             <li key={item?.id || item?.label || item?.name}>
//               {(item?.src || item?.url) && (
//                 <img
//                   src={(item?.src || item?.url)}
//                   alt={item.name || 'preview'}
//                   style={{ maxWidth: '100px',height: '100px',
//                   objectFit: 'cover', display: 'block' }}
//                 />
//               )}
//               {item?.label && <p>{item.label}</p>}
//               {!item?.label && !item?.src &&  <p>{console.log("img", item , !item?.src, item?.url)} </p>}
//             </li>
//           ))}
//         </ul>
//       );
//     } 

//     if (typeof val === 'object') {
//       // Handle known object structures
//       if (val.templateName) return val.templateName;
//       if (val.label) return val.label;

//       return (
//         <ul style={{ margin: 0, paddingLeft: '1rem' }}>
//           {Object.entries(val).map(([key, nestedVal]) => (
//             <li key={key}>
//               <strong>{key}:</strong> {String(nestedVal)}
//             </li>
//           ))}
//         </ul>
//       );
//     }


//     return String(val);
//   };

//   return (
//     <div className={classes.row}>
//       <div className={classes.text}>{label}</div>
//       <div className={classes.text}>{renderValue(value)}</div>
//     </div>
//   );
// };

// export default PreviewRow;



// ChallengePreview.jsx
/* eslint-disable jsx-a11y/label-has-associated-control, no-unneeded-ternary, jam3/no-sanitizer-with-danger */

import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BsInfoCircle } from 'react-icons/bs';
import DOMPurify from 'dompurify';

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";

import { formatDateToShortMonth } from '../ChallengeDetails/View';

/* =============================================================================
   Styles
   ============================================================================= */
const useStyles = makeStyles(() => ({
  wrapper: { margin: '1rem 0 2rem 0', padding: '1rem', background: '#fff' },
  title: { fontFamily: 'VodafoneRg-Regular', fontSize: '1.25rem', marginBottom: '1rem', color: '#333' },
  subtitle: { fontFamily: 'VodafoneRg-Regular', fontSize: '1rem', color: '#9b9494', marginBottom: '2rem' },
}));

const useSectionStyles = makeStyles(() => ({
  sectionBox: {
    backgroundColor: '#e6000117',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginBottom: '1.5rem',
  },
  icon: {
    display: 'inline-block',
    backgroundColor: '#e6000117',
    padding: '4.5px',
    borderRadius: '50%',
    marginRight: '0.5rem',
  },
  sectionTitle: { fontFamily: 'VodafoneRg-Bold', fontSize: '1.125rem', color: '#333', margin: '0.5rem 0' },
  sectionSubtitle: { fontFamily: 'VodafoneRg-Regular', fontSize: '1rem', color: '#333' },
}));

const useRowStyles = makeStyles(() => ({
  row: {
    display: 'grid',
    gridTemplateColumns: '40% 1fr',
    gap: '1rem',
    borderBottom: '1px solid #ccc',
    padding: '1rem 0',
  },
  text: { fontFamily: 'VodafoneRg-Regular', fontSize: '1rem', color: '#333', wordBreak: 'break-word' },
}));

/* =============================================================================
   Utilities
   ============================================================================= */

const isEmpty = (v) => v === null || v === undefined || v === '';

const toKey = (v) => {
  if (v == null) return undefined;
  if (typeof v === 'object') return String(v.id ?? v.value ?? v.key ?? v.name ?? '').trim() || undefined;
  const s = String(v).trim();
  return s.length ? s : undefined;
};

const parseId = (maybeId) => {
  const raw = typeof maybeId === 'object' && maybeId !== null ? maybeId.id : maybeId;
  const parsed = parseInt(String(raw ?? '').trim(), 10);
  return Number.isNaN(parsed) ? undefined : parsed;
};

const sanitizeHtml = (html) =>
  DOMPurify.sanitize(String(html || ''), {
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title', 'style'],
    ALLOWED_TAGS: [
      'b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li', 'a', 'img',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div',
    ],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload'],
  });


const toEmailIfPossible = (v) => {
  if (!v) return undefined;
  const s = String(v).trim();

  // URL-wrapped email in path (e.g., http://host/onkar.sharma@yahoo.co.in)
  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s);
      const maybeEmail = decodeURIComponent(u.pathname).replace(/^\//, '');
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(maybeEmail)) return maybeEmail;
    } catch { /* ignore */ }
  }

  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) return s;

  if (typeof v === 'object' && v !== null) {
    const candidate = v.email || v.mail || v.userPrincipalName || v.upn || v.ownerEmail || v.userEmail;
    if (candidate && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(candidate))) return String(candidate);
  }

  return undefined;
};

/* =============================================================================
   Minimal Presentational Primitives
   ============================================================================= */

const Row = React.memo(function Row({ label, children }) {
  const classes = useRowStyles();
  return (
    <div className={classes.row}>
      <div className={classes.text}>{label}</div>
      <div className={classes.text}>{children}</div>
    </div>
  );
});

const Section = React.memo(function Section({ title, subtitle, children }) {
  const classes = useSectionStyles();
  return (
    <div className={classes.sectionBox} aria-label={`${title} section`}>
      <div className={classes.icon} aria-hidden="true">
        <BsInfoCircle />
      </div>
      <h3 className={classes.sectionTitle}>{title}</h3>
      <p className={classes.sectionSubtitle}>{subtitle}</p>
      {children}
    </div>
  );
});

/* =============================================================================
   Renderers (schema targets these — no guessing)
   ============================================================================= */

const RenderText = ({ value }) => <span>{isEmpty(value) ? 'N/A' : String(value)}</span>;

const RenderHtml = ({ value }) => {
  if (isEmpty(value)) return <span>N/A</span>;
  const safe = sanitizeHtml(value);
  return safe?.trim() ? <div dangerouslySetInnerHTML={{ __html: safe }} /> : <span>N/A</span>;
};


/**
 * Reusable helper: resolves an image URL from different shapes:
 * - string URL
 * - object with src/url
 * - array of such objects (uses the first item)
 */
function getImageSrc(value) {
  if (!value) return null;

  // If it's already a string URL
  if (typeof value === 'string') return value || null;

  // If it's an array, prefer first object
  if (Array.isArray(value)) {
    const first = value[0];
    if (first && typeof first === 'object') {
      return first.src ?? first.url ?? null;
    }
    return null;
  }

  // If it's an object
  if (typeof value === 'object') {
    return value.src ?? value.url ?? null;
  }

  return null;
}


const RenderImage = ({ value, alt = 'preview', width = 140, height = 140 }) => {
  const src = getImageSrc(value);
  if (!src) return <span>N/A</span>;
  return (
    <img
      src={ src }
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      style={{ objectFit: 'cover', display: 'block', borderRadius: 6 }}
      onError={(e) => {
        // Hide broken images without leaking URL
        e.currentTarget.replaceWith(document.createTextNode('N/A'));
      }}
    />
  );
};

const RenderList = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return <span>N/A</span>;
  return (
    // <ul style={{ margin: 0, paddingLeft: '1rem' }}>
    //   {items.map((item, idx) => {
    //     const key = toKey(item) ?? `${idx}`;
    //     const text =
    //       item?.label ??
    //       item?.title ??
    //       item?.name ??
    //       item?.communityName ??
    //       item?.templateName ??
    //       item?.displayName ??
    //       (typeof item === 'string' ? item : 'N/A');
    //     return <li key={key} style={{ margin: '0.25rem 0' }}>{String(text)}</li>;
    //   })}
    // </ul>
   
    <List>
      {items.sort((a, b) => a?.label?.localeCompare(b?.label))?.map((item, idx) => {
        console.log('items list filer ', item)
        const key = toKey(item) ?? `${idx}`;
        const text =
          item?.label ??
          item?.title ??
          item?.name ??
          item?.communityName ??
          item?.templateName ??
          item?.displayName ??
          (typeof item === 'string' ? item : 'N/A');
          return (
            <ListItem key={key} >
              <ListItemAvatar>
                <Avatar>{String(text)?.[0]?.toUpperCase() || "?"}</Avatar>
              </ListItemAvatar>
              <ListItemText > { String(text) || "(unnamed)"}</ListItemText>
            </ListItem>
          )
        })}
            
    </List>
  );
};

/* =============================================================================
   Main
   ============================================================================= */

export const ChallengePreview = (props) => {
  const classes = useStyles();
const {
  isAdmin = false,
  isInnovator,
  userEmail = 'N/A',
  innovateCategoryTypes = [],
  listIdeaTemplate = [],
  listScorecardTemplate = [],
  getInnovateChallengeIdDetails = null,
  listCommunitesChallenge = [],
  formData = {},
  selectedUsers,

} = props || {};

// console.log("selectedUsers==>", selectedUsers)
// ✅ Early return before any hook calls
// if (!getInnovateChallengeIdDetails) return null;



const {
  title,
  summary,
  category,
  startingDate,
  closingDate,
  termsAndConditions,
  coverPhoto,
  templateIdea,
  templateScorecard,
  communities,
  search:challengeOrganizerEmailListSelected
} = formData;

const {
  title: getTitleFromAPI,
  desc,
  starts,
  ends,
  categoryTypeId,
  image,
  challengeTemplateId,
  ideaTemplateId,
  termAndCondition,
  groupListK = [],
} = getInnovateChallengeIdDetails;

// const challengeOwnerDisplay = isAdmin ? userEmail : 'N/A';


// const selectedUsers1 = [
//   {
//       "label": "innovator@gmail.com",
//       "value": "innovator@gmail.com"
//   },
//   {
//       "label": "organizer1@gmail.com",
//       "value": "organizer1@gmail.com"
//   },
//   {
//     "label": "organizer2@gmail.com",
//     "value": "organizer2@gmail.com"
// }
// ]

// const challengeOrganizerEmailListSelected1 = [
//   {
//       "label": "innovator@gmail.com",
//       "value": "innovator@gmail.com"
//   },
//   {
//       "label": "organizer1@gmail.com",
//       "value": "organizer1@gmail.com"
//   }
// ]


const finalUsers = Array.from(
  new Map(
    [
      ...(selectedUsers || []),
      //  Convert challengeOrganizerEmailList (string -> object)
      ...(challengeOrganizerEmailListSelected || []),
      //  Add logged-in user conditionally
      ...[{ value: userEmail, label: userEmail }]
        
    ].map(item => {
      const value = item.value || item.label;

      return [
        value?.toLowerCase(),
        {
          ...item,
          value,
          label: item.label || value
        }
      ];
    })
  ).values()
);





const startDateFormatted = useMemo(
  () => formatDateToShortMonth(startingDate || starts?.dateString),
  [startingDate, starts]
);

const endDateFormatted = useMemo(
  () => formatDateToShortMonth(closingDate || ends?.dateString),
  [closingDate, ends]
);

const selectedType = useMemo(() => {
  const cid = parseId(category || categoryTypeId);
  if (!cid) return undefined;
  return innovateCategoryTypes.find((t) => parseId(t?.id) === cid);
}, [innovateCategoryTypes, category, categoryTypeId]);

const selectedIdeaTemplate = useMemo(() => {
  const ideaId = parseId(templateIdea || ideaTemplateId);
  if (!ideaId) return undefined;
  return listIdeaTemplate.find((tpl) => parseId(tpl?.id) === ideaId);
}, [listIdeaTemplate, templateIdea, ideaTemplateId]);

const selectedScorecardTemplate = useMemo(() => {
  const challengeTplId = parseId(templateScorecard || challengeTemplateId);
  if (!challengeTplId) return undefined;
  return listScorecardTemplate.find((tpl) => parseId(tpl?.id) === challengeTplId);
}, [listScorecardTemplate, templateScorecard, challengeTemplateId]);

const communityItems = useMemo(() => {
  if (!Array.isArray( groupListK) || groupListK.length === 0) return [];
  
  const setKeys = new Set(groupListK.map(toKey).filter(Boolean));

  return (listCommunitesChallenge || []).filter((grp) => {
    const gid = toKey(grp?.id ?? grp);
    return gid && setKeys.has(gid);
  });

}, [listCommunitesChallenge, groupListK]);

// const ownerEmail = toEmailIfPossible(challengeOwnerDisplay);

const SECTIONS = useMemo(
  () => [
    {
      title: 'Challenge Details',
      subtitle: 'Basic information about your challenge',
      rows: [
        { label: 'Challenge Title', type: 'text', get: () => title || getTitleFromAPI || 'N/A' },
        { label: 'Challenge Description', type: 'html', get: () => summary || desc },
        { label: 'Category', type: 'text', get: () => selectedType?.name || 'N/A' },
        { label: 'Submission Start Date', type: 'text', get: () => startDateFormatted || 'N/A' },
        { label: 'Submission End Date', type: 'text', get: () => endDateFormatted || 'N/A' },
        { label: 'Challenge Cover Photo', type: 'image', get: () => coverPhoto || image || null },
        { label: 'Terms and Conditions', type: 'html', get: () => termsAndConditions || termAndCondition },
      ],
    },
    {
      title: 'Idea Template Selection',
      subtitle: 'Details of the selected idea template',
      rows: [
        { label: 'Selected Idea Template Name', type: 'text', get: () => selectedIdeaTemplate?.templateName || 'N/A' },
      ],
    },
    {
      title: 'Evaluation Workflow',
      subtitle: 'Details of the selected scorecard template',
      rows: [
        { label: 'Evaluation Method', type: 'text', get: () => 'Scorecard' },
        { label: 'Selected Scorecard Template Name', type: 'text', get: () => selectedScorecardTemplate?.templateName || 'N/A' },
      ],
    },
    {
      title: 'Owner & Communities',
      subtitle: 'Challenge ownership and participation settings',
      rows: [
        { label: 'is Admin', type: 'text', get: () => String(isAdmin) },
        { label: 'Challenge Owner', type: 'text', get: () => userEmail || 'N/A' },
        { label: 'Challenge Manager', type: 'list', get: () => finalUsers || 'N/A' },
        { label: 'Communities', type: 'list', get: () => (  communities ||  communityItems || [] ) },
      ],
    },
  ],
  // ✅ Include all values referenced inside the memo
  [
    title,
    getTitleFromAPI,
    summary,
    desc,
    selectedType,
    startDateFormatted,
    endDateFormatted,
    coverPhoto,
    image,
    termsAndConditions,
    termAndCondition,
    selectedIdeaTemplate,
    selectedScorecardTemplate,
    isAdmin,
    // ownerEmail,
    communityItems,
    
  ]
);


  return (
    <div className={classes.wrapper}>
      <h2 className={classes.title}>Challenge Summary</h2>
      <p className={classes.subtitle}>Review your challenge details before submitting</p>

      {SECTIONS.map((sec) => (
        <Section key={sec.title} title={sec.title} subtitle={sec.subtitle}>
          {sec.rows.map((r) => {
            const value = r.get?.();
            switch (r.type) {
              case 'html':
                return (
                  <Row key={r.label} label={r.label}>
                    <RenderHtml value={value} />
                  </Row>
                );
              case 'image':
                return (
                  <Row key={r.label} label={r.label}>
                    <RenderImage value={value} alt={r.label} />
                  </Row>
                );
              case 'list':
                return (
                  <Row key={r.label} label={r.label}>
                    <RenderList items={value} />
                  </Row>
                );
              case 'text':
              default:
                return (
                  <Row key={r.label} label={r.label}>
                    <RenderText value={value} />
                  </Row>
                );
            }
          })}
        </Section>
      ))}
    </div>
  );
};

export default ChallengePreview;